// removed by extract-text-webpack-plugin
module.exports = {"product-slick":"product-slick","hinghlight-item":"hinghlight-item","slick-next":"slick-next","slick-prev":"slick-prev","slick-arrow":"slick-arrow","slick-disabled":"slick-disabled","product-category-container":"product-category-container","product-left-content":"product-left-content","product-iton":"product-iton","title-black":"title-black","view-more-link":"view-more-link","product-right-content":"product-right-content","product-item":"product-item","product-name":"product-name","wrap-image":"wrap-image"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_HighlightProductByCategoryContainer.scss
// module id = ./components/home/sub-view/_HighlightProductByCategoryContainer.scss
// module chunks = 0